<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{$ml.get('shared.monthlyPayrollTables')}}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get('shared.dashboard')}}</span>
        </li>
        <li>
          <i class="fa fa-cogs"></i>
          <span>{{$ml.get('shared.settings')}}</span>
        </li>
        <li>
          <span>{{$ml.get('shared.monthlyPayrollTables')}}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-4">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{$ml.get('monthlyPayrollTables.monthlyPayrolColumnlList')}}</span>
              </h3>
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body">
              <div
                v-show="monthlyPayrollList.length > 0"
                class="table-responsive no-padding"
                :style="windowHeightSize"
              >
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="monthlyPayroll in monthlyPayrollList" :key="monthlyPayroll.id">
                      <td>{{monthlyPayroll.shortCode}}</td>
                      <td>{{monthlyPayroll.name}}</td>
                      <td class="pull-right">
                        <button
                          type="button"
                          @click="getMonthlyPayroll(monthlyPayroll.id)"
                          class="btn btn-primary btn-sm"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="monthlyPayrollList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i> {{$ml.get('monthlyPayrollTables.monthlyPayrollTableRecordNotFound')}}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                <span>{{$ml.get('monthlyPayrollTables.monthlyPayrollInfo')}}</span>
              </h3>
              <div class="box-tools pull-right">
                <button v-show="authControl == 0"
                  type="button"
                  @click="newMonthlyPayroll()"
                  class="btn btn-sm btn-warning "
                >{{$ml.get('monthlyPayrollTables.newMonthlyPayroll')}}</button>
              </div>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>{{$ml.get('monthlyPayrollTables.shortCode')}}</label>
                    <input
                      v-model="monthlyPayroll.shortCode"
                      type="text"
                      class="form-control"
                      autocomplete="off"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>{{$ml.get('monthlyPayrollTables.payrollColumnName')}}</label>
                    <input
                      v-model="monthlyPayroll.name"
                      type="text"
                      class="form-control"
                      autocomplete="off"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4" align="center" style="margin-bottom:10px;">
                  <span class="form-control checkbox">
                    <label>
                      <input
                        :checked="monthlyPayroll.ssk"
                        @change="monthlyPayroll.ssk==true ? monthlyPayroll.ssk=false : monthlyPayroll.ssk=true"
                        type="checkbox"
                      />
                      {{$ml.get('monthlyPayrollTables.ssk')}}
                    </label>
                  </span>
                </div>
                <div class="col-sm-4" align="center" style="margin-bottom:10px;">
                  <span class="form-control checkbox">
                    <label>
                      <input
                        :checked="monthlyPayroll.total"
                        @change="monthlyPayroll.total==true ? monthlyPayroll.total=false : monthlyPayroll.total=true"
                        type="checkbox"
                      />
                      {{$ml.get('monthlyPayrollTables.total')}}
                    </label>
                  </span>
                </div>
                <div class="col-sm-4" align="center" style="margin-bottom:10px;">
                  <span class="form-control checkbox">
                    <label>
                      <input
                        :checked="monthlyPayroll.work"
                        @change="monthlyPayroll.work==true ? monthlyPayroll.work=false : monthlyPayroll.work=true"
                        type="checkbox"
                      />
                      {{$ml.get('monthlyPayrollTables.work')}}
                    </label>
                  </span>
                </div>
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoadingDetail">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-footer">
              <div class="pull-right">
                <button
                  v-show="!isNewMonthlyPayroll && authControl == 0"
                  type="button"
                  data-toggle="modal"
                  data-target="#modal-sil"
                  class="btn btn-sm btn-danger "
                  style="margin: 5px; width:120px;"
                >{{$ml.get('general.delete')}}</button>
                <button
                  v-show="isNewMonthlyPayroll && authControl == 0"
                  type="button"
                  data-toggle="modal"
                  data-target="#modal-kaydet"
                  class="btn btn-sm btn-success "
                  style="margin: 5px; width:120px;"
                >{{$ml.get('general.save')}}</button>
                <button
                  v-show="!isNewMonthlyPayroll && authControl == 0"
                  type="button"
                  data-toggle="modal"
                  data-target="#modal-guncelle"
                  class="btn btn-sm btn-success "
                  style="margin: 5px; width:120px;"
                >{{$ml.get('general.update')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL START-->
      <div class="modal modal-info fade" id="modal-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.update')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{this.monthlyPayroll.shortCode}} - {{this.monthlyPayroll.name}}</span>
              </div>
              <br />
              <p></p>
              <span>{{$ml.get('monthlyPayrollTables.isContinueMonthlyPayrollUpdate')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="saveMonthlyPayroll()" class="btn btn-info" data-dismiss="modal">
                <i class="fa fa-refresh"></i>
                <span>{{$ml.get('general.update')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-success fade" id="modal-kaydet">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.save')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <p>{{this.monthlyPayroll.shortCode}} - {{this.monthlyPayroll.name}}</p>
              <span>{{$ml.get('monthlyPayrollTables.isContinueMonthlyPayrollSave')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="saveMonthlyPayroll()" class="btn btn-success" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{$ml.get('general.save')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="modal-sil">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.delete')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{this.monthlyPayroll.shortCode}} - {{this.monthlyPayroll.name}}</span>
              </div>
              <br />
              <p></p>
              <span>{{$ml.get('monthlyPayrollTables.isContinueMonthlyPayrollDelete')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="deleteMonthlyPayroll()" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-trash"></i>
                <span>{{$ml.get('general.delete')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      monthlyPayroll: {
        id: null,
        shortCode: "",
        name: "",
        ssk: true,
        total: true,
        work: true
      },
      monthlyPayrolls: [],
      isNewMonthlyPayroll: true
    };
  },
  computed: {
    authControl(){
      return this.$store.getters.getAuthAyarlar;
    },
    monthlyPayrollList() {
      return this.monthlyPayrolls;
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    newMonthlyPayroll() {
      this.isLoadingDetail = true;
      this.isNewMonthlyPayroll = true;
      this.monthlyPayroll.id = null;
      this.monthlyPayroll.shortCode = "";
      this.monthlyPayroll.name = "";
      this.monthlyPayroll.ssk = true;
      this.monthlyPayroll.total = true;
      this.monthlyPayroll.work = true;
      this.monthlyPayroll.ipAddress = true;
      this.monthlyPayroll.port = true;
      this.isLoadingDetail = false;
    },
    async deleteMonthlyPayroll() {
      try {
        this.isLoadingDetail = true;
        let id = this.monthlyPayroll.id;
        const response = await this.$axios
          .delete("/MonthlyPayroll/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.getMonthlyPayrolls();
        this.newMonthlyPayroll();
        alertify.success(this.$ml.get('alerts.deletedSuccessfully'));
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    async saveMonthlyPayroll() {
      if (
        this.monthlyPayroll.name == "" ||
        this.monthlyPayroll.shortCode == ""
      ) {
        alertify.warning(this.$ml.get('alerts.pleaseEnterShortCodeAndName'));
        return;
      }
      this.isLoadingDetail = true;
      if (this.isNewMonthlyPayroll) {
        try {
          let monthlyPayroll2 = this.monthlyPayroll;
          const response = await this.$axios
            .post("/MonthlyPayroll", {
              name: monthlyPayroll2.name,
              shortCode: monthlyPayroll2.shortCode,
              ssk: monthlyPayroll2.ssk,
              total: monthlyPayroll2.total,
              work: monthlyPayroll2.work
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get('errors.connectionError'));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          let id = response.data.id;
          if (response.status == 200) {
            alertify.success(this.$ml.get('alerts.savedSuccessfully'));
          } else {
            alertify.error(response.message);
          }
          this.getMonthlyPayrolls();
          this.getMonthlyPayroll(id);
          this.isNewMonthlyPayroll = false;
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        try {
          let monthlyPayroll2 = this.monthlyPayroll;
          const response = await this.$axios
            .post("/MonthlyPayroll/" + monthlyPayroll2.id, {
              name: monthlyPayroll2.name,
              shortCode: monthlyPayroll2.shortCode,
              ssk: monthlyPayroll2.ssk,
              total: monthlyPayroll2.total,
              work: monthlyPayroll2.work
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get('errors.connectionError'));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          if (response.status == 200) {
            alertify.success(this.$ml.get('alerts.updatedSuccessfully'));
          } else {
            alertify.error(response.message);
          }
          this.getMonthlyPayrolls();
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoadingDetail = false;
        }
      }
    },
    async getMonthlyPayroll(id) {
      try {
        this.isLoadingDetail = true;
        const response = await this.$axios
          .get("/MonthlyPayroll/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.isNewMonthlyPayroll = false;
        this.monthlyPayroll.id = id;
        this.monthlyPayroll.shortCode = response.data.shortCode;
        this.monthlyPayroll.name = response.data.name;
        this.monthlyPayroll.ssk = response.data.ssk;
        this.monthlyPayroll.total = response.data.total;
        this.monthlyPayroll.work = response.data.work;
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    async getMonthlyPayrolls() {
      try {
        this.isLoading = true;
        const monthlyPayrolls = [];
        const response = await this.$axios
          .get("/MonthlyPayroll")
          .then(response => {
            response.data.forEach(doc => {
              monthlyPayrolls.push({
                id: doc.id,
                shortCode: doc.shortCode,
                name: doc.name,
                ssk: doc.ssk,
                total: doc.total,
                work: doc.work
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.monthlyPayrolls = monthlyPayrolls;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(this.$ml.get('alerts.youAreOnlyAuthorizedToViewThisPage'));
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAuthControl();
    await this.getMonthlyPayrolls();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/monthlyPayrollTables/MonthlyPayrollTables.vue